// @flow

const referralsHomeStyles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex'
  })
};

export default referralsHomeStyles;
